import publicUrls from "../../../routes/publicUrls";
import React, { useState, useRef, useCallback } from "react";
import ModeAuction from "./ModeAuction1";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography, Divider, Drawer, IconButton, Stack, MenuItem, Select, FormControl } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import FilterListIcon from "@mui/icons-material/FilterList";

import { encodeId } from "../../../hash";


export default function Auction() {
  const isMobile = useMediaQuery("(max-width:991px)");
  const isPhone = useMediaQuery("(max-width:600px)");

  const [viewMode, setViewMode] = useState("grid");
  const [pageNumber, setPageNumber] = useState(1);
  const [sortBy, setSortBy] = useState("newest");

  // Filters
  const [live, setLive] = useState("LIVE_AUCTION");
  const [online, setOnline] = useState("ONLINE_AUCTION");
  const [timeAuction, setTimeAuction] = useState("TIME_AUCTION");
  const [checked, setChecked] = useState(true);
  const [checked1, setChecked1] = useState(true);
  const [checked2, setChecked2] = useState(true);
  
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const { books, hasMore, loading, errorMsg } = ModeAuction(
    pageNumber,
    live,
    timeAuction,
    online
  );

  // Sorting Logic (Local sort example)
  const sortedBooks = [...books].sort((a, b) => {
    if (sortBy === "newest") return new Date(b.date_start) - new Date(a.date_start);
    if (sortBy === "oldest") return new Date(a.date_start) - new Date(b.date_start);
    return 0;
  });

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const resetAndFilter = (setter, valSetter, e) => {
    valSetter(e.target.checked ? e.target.value : null);
    setter(e.target.checked);
    setPageNumber(1);
  };

  const GotoPage = async (id, name, type, cover, slug) => {
    // ✅ I-save ang Auction ID at Name bago lumipat ng page
   
    if (type) localStorage.setItem("auctionType", type.toString());
  
    // ✅ Lipat na sa target URL
    window.location.href = publicUrls.auction(slug, encodeId(id));
  };

  const FilterContent = () => (
    <Box sx={{ p: isMobile ? 3 : 0 }}>
      <Typography variant="overline" sx={{ fontWeight: 800, color: '#999', letterSpacing: 2 }}>Catalog</Typography>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, fontFamily: 'serif' }}>SALES</Typography>
      <Divider sx={{ mb: 3 }} />
      <FormGroup>
        <FormControlLabel
          control={<Checkbox checked={checked} onChange={(e) => resetAndFilter(setChecked, setLive, e)} value="LIVE_AUCTION" color="default" />}
          label={<Typography sx={{ fontSize: 14, fontWeight: 500 }}>Live Auction</Typography>}
        />
        <FormControlLabel
          control={<Checkbox checked={checked1} onChange={(e) => resetAndFilter(setChecked1, setOnline, e)} value="ONLINE_AUCTION" color="default" />}
          label={<Typography sx={{ fontSize: 14, fontWeight: 500 }}>Online Auction</Typography>}
        />
        <FormControlLabel
          control={<Checkbox checked={checked2} onChange={(e) => resetAndFilter(setChecked2, setTimeAuction, e)} value="TIME_AUCTION" color="default" />}
          label={<Typography sx={{ fontSize: 14, fontWeight: 500 }}>Time Auction</Typography>}
        />
      </FormGroup>
    </Box>
  );

  return (
    <section style={{ background: "#fff", paddingTop: 40, minHeight: '100vh' }}>
      <div className="container">
        <div className="row">
          
          
          {!isMobile && (
            <div className="col-lg-3">
              <Box sx={{ position: "sticky", top: 120, pr: 2 }}>
                <FilterContent />
              </Box>
            </div>
          )}

          <div className="col-lg-9">
            
            <Box sx={{ 
              display: "flex", 
              justifyContent: "space-between", 
              mb: 4, 
              alignItems: "center",
              flexWrap: 'wrap',
              gap: 2
            }}>
              <Stack direction="row" spacing={1} alignItems="center">
                {isMobile && (
                  <Button 
                    onClick={() => setMobileFilterOpen(true)}
                    variant="outlined" 
                    startIcon={<FilterListIcon />}
                    sx={{ color: '#000', borderColor: '#ccc', borderRadius: 0, textTransform: 'none' }}
                  >
                    Filter
                  </Button>
                )}
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    displayEmpty
                    sx={{ borderRadius: 0, fontSize: '13px' }}
                  >
                    <MenuItem value="newest">Sort by: Newest</MenuItem>
                    <MenuItem value="oldest">Sort by: Oldest</MenuItem>
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction="row" spacing={0} sx={{ border: '1px solid #eee', height: 40 }}>
  <IconButton 
    onClick={() => setViewMode("grid")} 
    sx={{ 
      borderRadius: 0, 
      // Kapag active, black bg; kapag hindi, white bg
      bgcolor: viewMode === "grid" ? "#000" : "#fff", 
      // Kapag active, white icon; kapag hindi, black icon
      color: viewMode === "grid" ? "#fff" : "#000",
      "&:hover": {
        bgcolor: viewMode === "grid" ? "#333" : "#f5f5f5"
      }
    }}
  >
    <GridViewIcon sx={{ fontSize: '1.2rem' }} />
  </IconButton>

  <IconButton 
    onClick={() => setViewMode("list")} 
    sx={{ 
      borderRadius: 0, 
      bgcolor: viewMode === "list" ? "#000" : "#fff", 
      color: viewMode === "list" ? "#fff" : "#000",
      "&:hover": {
        bgcolor: viewMode === "list" ? "#333" : "#f5f5f5"
      }
    }}
  >
    <ViewListIcon sx={{ fontSize: '1.2rem' }} />
  </IconButton>
</Stack>
            </Box>

            
            


<div className="row g-4">
  
  {!loading && sortedBooks.length === 0 ? (
    <div className="col-12">
      <Box 
        sx={{ 
          textAlign: "center", 
          py: 10, 
          border: '1px dashed #ccc', 
          borderRadius: 2,
          mt: 2 
        }}
      >
        <Typography variant="h6" sx={{ color: '#999', fontFamily: 'serif' }}>
          No records found
        </Typography>
        <Typography variant="body2" sx={{ color: '#bbb' }}>
          Try adjusting your filters to find more auctions.
        </Typography>
      </Box>
    </div>
  ) : (
    sortedBooks.map((value, i) => {
      const isList = viewMode === "list";
      const colClass = isList ? "col-12" : "col-6 col-lg-4";

      return (
        <div
  key={value.id}
  className={colClass}
  ref={sortedBooks.length === i + 1 ? lastBookElementRef : null}
  style={{ paddingBottom: isList ? "0px" : (isPhone ? "10px" : "20px") }} // Inadjust ang padding
>
  <Box 
    onClick={() => GotoPage(value.id, value.d_name, value.c_type, value.cover, value.c_slug)}
    sx={{ 
      cursor: "pointer",
      display: isList ? "flex" : "flex", // Force flex for hover box consistency
      flexDirection: isList ? "row" : "column",
      gap: isList ? (isPhone ? 2 : 4) : 0,
      transition: 'all 0.3s ease-in-out',
      // ✅ SOTHEBY'S HOVER CARD STYLE
      p: isList ? 0 : 2, // Padding para sa grid box hover
      border: "1px solid transparent",
      "&:hover": { 
        borderColor: isList ? "transparent" : "#eee", // Grid lang ang may border reveal
        boxShadow: isList ? "none" : "0px 10px 20px rgba(0,0,0,0.05)",
        backgroundColor: isList ? "transparent" : "#fff",
        "& .image-hover": {
           transform: "scale(1.05)",
           backgroundColor: "#f0f0f0"
        }
      },
      pb: isList ? 4 : 2,
      borderBottom: isList ? "1px solid #eee" : "none", 
    }}
  >
    
    <Box 
      sx={{ 
        width: isList ? (isPhone ? '120px' : '350px') : '100%',
        height: isList ? (isPhone ? '120px' : '250px') : (isPhone ? '220px' : '380px'),
        flexShrink: 0,
        backgroundColor: "#f9f9f9",
        overflow: 'hidden', // Required for zoom effect
        position: 'relative',
        mb: isList ? 0 : 2 
      }} 
    >
      <Box 
        className="image-hover"
        sx={{ 
          width: '100%',
          height: '100%',
          backgroundImage: `url(${value.cover || "https://placehold.co/400x500?text=No+Image+Available"})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          transition: "transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1)"
        }}
      />
    </Box>

    
    <Box sx={{ 
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: isList ? 'center' : 'flex-start',
      px: isList ? 0 : 0.5 
    }}>
      
      <Box sx={{ 
        display: 'flex', 
        flexDirection: isList ? 'column' : 'row', 
        justifyContent: isList ? 'flex-start' : 'space-between', 
        alignItems: isList ? 'flex-start' : 'center', 
        mb: 0.5 
      }}>
        <Typography 
          variant="caption"
          sx={{ 
            fontSize: isPhone ? 8 : "0.7rem",
            color: '#999', 
            fontWeight: 700, 
            textTransform: 'uppercase', 
            letterSpacing: 1.5 
          }}
        >
          {value.c_type?.replace("_", " ")}
        </Typography>

        <Typography 
          variant="caption" 
          sx={{ 
            fontSize: isPhone ? 8 : "0.7rem",
            color: value.auction_status === "ONGOING" ? '#ea1010' : '#999', 
            fontWeight: 800, 
            textTransform: 'uppercase', 
            letterSpacing: 1,
            mt: isList ? 0.2 : 0 
          }}
        >
          {value.auction_status}
        </Typography>
      </Box>

      
      <Typography 
        variant="caption" 
        sx={{ 
          color: '#666', 
          fontWeight: 400, 
          fontSize: '0.75rem',
          mb: 0.5, 
          display: 'block',
          textTransform: 'uppercase'
        }}
      >
        {value.auction_name}
      </Typography>

      
      <Typography 
        variant="h6" 
        sx={{ 
          fontWeight: 700, 
          lineHeight: 1.2, 
          mb: 1, 
          fontFamily: '"Playfair Display", serif', // Sotheby's style font
          fontSize: isPhone ? '1rem' : '1.3rem',
          color: '#1a1a1a',
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        {value.d_name}
      </Typography>

      
      <Box>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#888', 
            fontWeight: 400,
            fontSize: isPhone ? '0.75rem' : '0.85rem',
            letterSpacing: 0.5,
          }}
        >
          {new Date(value.date_start).toLocaleDateString("en-US", { 
            month: 'long', 
            day: 'numeric', 
            year: 'numeric' 
          })}
        </Typography>
      </Box>
    </Box>
  </Box>
</div>
      );
    })
  )}
</div>

            {loading && <Box sx={{ textAlign: "center", py: 10 }}><CircularProgress color="inherit" size={30} /></Box>}
          </div>
        </div>
      </div>

      
      <Drawer
        anchor="bottom"
        open={mobileFilterOpen}
        onClose={() => setMobileFilterOpen(false)}
        PaperProps={{ sx: { borderRadius: '15px 15px 0 0', p: 2 } }}
      >
        <Box sx={{ width: 40, height: 4, bgcolor: '#ddd', borderRadius: 2, m: '0 auto 15px' }} />
        <FilterContent />
        <Button 
          fullWidth 
          variant="contained" 
          onClick={() => setMobileFilterOpen(false)}
          sx={{ mt: 3, bgcolor: '#000', borderRadius: 0, py: 1.5, "&:hover": {bgcolor: '#333'} }}
        >
          View Results
        </Button>
      </Drawer>

      
    </section>
  );
}